var initializeBlockMemberships = function(block){

    jQuery("#membership-select", block).on("change", function(){
		
		var index = jQuery(this).val();
		
		jQuery("table.membership-table tr").each(function(){
			
			var tableRow = jQuery(this);
			
			jQuery("th:gt(0)", tableRow).addClass("no-show").removeClass("show");
			jQuery("td:gt(0)", tableRow).addClass("no-show").removeClass("show");
			
			jQuery("th:eq(" + index + ")", tableRow).addClass("show").removeClass("no-show");
			jQuery("td:eq(" + index + ")", tableRow).addClass("show").removeClass("no-show");
			
		});

	});
	
	jQuery('spektrix-memberships').each(function(){
		
		jQuery(this)[0].addEventListener('success', function (e) {
			window.location.href = "/cart/";
		});
		
		jQuery(this)[0].addEventListener('fail', function (e) {
			window.location.href = "/cart/";
		});
		
	});

}

//initialize each block on front end
jQuery(document).ready(function(){
    jQuery('.wp-block-memberships').each(function(){
        initializeBlockMemberships(jQuery(this));
    });
});

//initialize dynamic block preview in the editor
if(window.acf)
    window.acf.addAction('render_block_preview/type=memberships', initializeBlockMemberships);
